import React from 'react';
import {FormControl, Textarea, FormHelperText} from '@chakra-ui/react';
import {ConfigFormLabel} from './ConfigFormLabel';

export const PromptTextEditor = ({
  prompt,
  isDisabled = false,
  onPromptChange,
}: {
  prompt: string;
  isDisabled?: boolean;
  onPromptChange: (newPrompt: string) => void;
}) => {
  return (
    <FormControl isRequired>
      <ConfigFormLabel>Prompt</ConfigFormLabel>
      <Textarea
        isDisabled={isDisabled}
        onChange={(e) => {
          onPromptChange(e.target.value);
        }}
        rows={5}
        placeholder="Ask your AI analyst anything..."
        value={prompt}
      />
      <FormHelperText textColor="kgray.300">
        Prompting is most successful when you phrase your prompt as a question
        about a single account, like “Does this company have brick and mortar
        locations?”
      </FormHelperText>
    </FormControl>
  );
};
